export function WorkflowStatusIcon({ status, color, className = "h-3.5 w-3.5" }: { status: string; color: string; className?: string }) {
  return <svg viewBox="0 0 16 16" className={className} aria-hidden="true">
    <circle cx="8" cy="8" r="6" fill="none" stroke={color} strokeWidth="1.8" strokeDasharray={status === "backlog" ? "2.5 2" : undefined} />
    {status === "started" && <path d="M8 2.5 A5.5 5.5 0 0 1 8 13.5 Z" fill={color} />}
    {status === "pending" && <path d="M6 5v6M10 5v6" stroke={color} strokeWidth="1.8" strokeLinecap="round" />}
    {(status === "done" || status === "completed") && <>
      {status === "completed" && <circle cx="8" cy="8" r="6" fill={color} />}
      <path d="M5 8.2l2 2 4-4.4" stroke={status === "completed" ? "#0f1011" : color} strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>}
    {status === "canceled" && <>
      <circle cx="8" cy="8" r="6" fill={color} />
      <path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="#0f1011" strokeWidth="1.6" strokeLinecap="round" />
    </>}
  </svg>;
}
